import React from "react";
import Scrollbar from "react-scrollbars-custom";
import PollListDetail from "views/Teams/TeamPoll/PollListDetail/PollListDetail";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import "assets/scss/partials/microsoftTeams.scss";

export default ({ setDialog, dialog, pollIdd, pollStatus }) => {
  return (
    <>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader">
          {" "}
          Poll List Detail
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div>
          <Scrollbar style={{ height: "calc(100vh - 100px)" }}>
            <div>
              <div>
                <PollListDetail pollIdd={pollIdd} pollStatus={pollStatus} />
              </div>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
